import axios from "axios";
import JwtService from "@/services/jwt.service";
import ApiService from "@/services/api.service";
import { API_URL } from "@/services/config.service";

const state = {
  users: [],
  user: [],
  username: null,
  scopes: [],
  //token: localStorage.getItem("accees_token") || null,
  apiUrl: API_URL + "/users",
  axiosConfig: {
    headers: {
      "Content-Type": "application/json",
       //Token: JwtService.getToken()
      //  Authorization: "access_token" + JwtService.getToken()
       Authorization: `Bearer ${JwtService.getToken()}`
    }
  }
};

const getters = {
  allUsers: state => state.users,
  loggedIn: state => state.token !== null,
  userName: state => state.username,
  userScopes: state => state.scopes
};

const mutations = {
  setUsers: (state, payload) => (state.users = payload),
  addUser: (state, payload) => state.users.push(payload),
  deleteUser: (state, index) => state.users.splice(index, 1),
  //retrieveToken: (state, token) => (state.token = token),
  //destroyToken: state => (state.token = null),
  // setUsername: (state, username) => (state.username = username),
  setUserScope: (state, scopes) => (state.scopes = scopes)
};

const actions = {
  fetchUsers: async ({ state, commit }) => {
    try {
      //console.log(state.axiosConfig);
     // const response = await axios.get(state.apiUrl, state.axiosConfig);
     const response = await ApiService.get("users");
      commit("setUsers", response.data.users);
      
      return response.data.users;
    } catch (error) {
      commit("setUsers", []);
    }
  },
  saveUser: async ({ state }, payload) => {
    try {
      let response = await axios.post(
        state.apiUrl + "/add",
        payload,
        state.axiosConfig
      );

      if (response.data.message.error) {
        return { error: response.data.message.error };
      }

      if (response.status == 200) {
        return { success: response.data.message.success };
      }
    } catch (error) {}
  },
  updateUser: async ({ state }, payload) => {
    try {
      let response = await axios.put(
        state.apiUrl + "/" + payload["user_id"],
        payload,
        state.axiosConfig
      );
      if (response.data.message.error) {
        return { error: response.data.message.error };
      }

      if (response.status == 200) {
        return { success: response.data.message.success };
      }
    } catch (error) {}
  },
  deleteUser: async ({ state }, payload) => {
    try {
      let response = await axios.delete(
        state.apiUrl + "/" + payload["user_id"],
        state.axiosConfig
      );
      if (response.status == 200) {
        state.dispatch("deleteUser", state.countries.indexOf(payload));
        state.notification.push({ message: response.data });
      }
    } catch (error) {}
  }
  /*
  destroyToken(context) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer" + context.state.token;

    if (JwtService.getToken()) {
      console.log("h ousman")
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiUrl + "/logout")
          .then(response => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("user_id");
            context.commit("destroyToken");
            state.isAuthenticated = false;
            resolve(response);
          })
          .catch(error => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("user_id");
            context.commit("destroyToken");
            reject(error);
          });
      });
    }
  },
  retrieveToken(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(state.apiUrl + "/login", credentials, context.state.axiosConfig)
        .then(response => {
          const token = response.data.access_token;
          //console.log(token)
          localStorage.setItem("access_token", token);
          localStorage.setItem("user_id", response.data.user);
          context.commit("retrieveToken", response.data.user);
          context.commit("setUsername", response.data.user);
          context.commit("setUserScope", ["manifest", "general-settings"]);
          //state.isAuthenticated = true;
          resolve(response);
        })
        .catch(error => {
          //console.log(error);
          reject(error);
        });
    });
  } */
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
